export function formatDateTime(value?: string | null): string {
  if (!value) {
    return '-';
  }

  return new Intl.DateTimeFormat('pt-PT', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function formatCurrency(value?: string | number | null): string {
  if (value === undefined || value === null || value === '') {
    return '-';
  }

  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR',
  }).format(Number(value));
}

/**
 * Short pt-PT relative time for recent events ("há 12 min", "há 3 h").
 * Returns '-' for missing values and clamps the future to "agora", since a
 * server/client clock skew should not surface as "daqui a 2 min".
 */
export function formatRelativeTime(value?: string | null, now: Date = new Date()): string {
  if (!value) {
    return '-';
  }

  const elapsedMinutes = Math.floor((now.getTime() - new Date(value).getTime()) / 60000);

  if (elapsedMinutes < 1) {
    return 'agora';
  }
  if (elapsedMinutes < 60) {
    return `há ${elapsedMinutes} min`;
  }

  const elapsedHours = Math.floor(elapsedMinutes / 60);
  if (elapsedHours < 24) {
    return `há ${elapsedHours} h`;
  }

  const elapsedDays = Math.floor(elapsedHours / 24);
  return elapsedDays === 1 ? 'há 1 dia' : `há ${elapsedDays} dias`;
}
